// @ts-nocheck
import { UAParser } from 'ua-parser-js'

export const isV2 = true

export const isProd = import.meta.env.VITE_ENV === 'production'
export const isTest = import.meta.env.VITE_ENV === 'test'
export const isDev = import.meta.env.VITE_ENV === 'dev'
export const isLocal = import.meta.env.VITE_ENV === 'loc'
export const isBuild = import.meta.env.VITE_COMMAND === 'build'
export const isServe = import.meta.env.VITE_COMMAND === 'serve'

const parser = new UAParser(navigator.userAgent)
export const params = new URLSearchParams(location.search)

const mockEnv = params.get('mock') as
  | 'pwa'
  | 'apl'
  | 'ap'
  | 'ebd'
  | 'app'
  | undefined
export const mockApp =
  mockEnv === 'app' || mockEnv === 'apl' || mockEnv === 'ebd'

// const mockIOSApp = mockEnv === 'iosapp' || mockEnv === 'apl'
// const mockAndroidApp = mockEnv === 'androidapp' || mockEnv === 'app' || mockEnv === 'apl' || mockEnv === 'ebd'

const debug = params.get('debug') != null || localStorage.getItem('_d') === '1'

export const isApl = params.get('type') === 'apl' || mockEnv === 'apl'
export const isAp = params.get('type') === 'ap' || mockEnv === 'ap'
export const isEbd = params.get('type') === 'ebd' || mockEnv === 'ebd'
// export const testWP = params.get('test') === '1'
export const noInstall = params.get('noinstall') === '1'

const ua = navigator.userAgent
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
export const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
export const isWindows = window.navigator.platform.toLowerCase().includes('win')
export const isMacOS =
  window.navigator.platform.toLowerCase().includes('mac') && !isIOS
export const isChromeOS =
  window.navigator.platform.toLowerCase().includes('linux') &&
  window.navigator.userAgent.toLowerCase().includes('cros')

export const isDesktop = isWindows || isMacOS || isChromeOS

export const isSupportPWA = 'serviceWorker' in navigator || mockEnv === 'pwa'
export const isFullSupportPWA =
  ('serviceWorker' in navigator &&
    'PushManager' in window &&
    'BeforeInstallPromptEvent' in window &&
    'caches' in window) ||
  mockEnv === 'pwa'
export const isProtocolHandlerSupported =
  'registerProtocolHandler' in navigator ||
  'canOpenProtocolHandler' in navigator

export const checkIfInPWA = () => {
  if (mockEnv === 'pwa') return true

  if (
    (window.matchMedia &&
      window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  ) {
    // 1 表示用户已接受安装(但可能安装失败) 2 已验证安装结果，确认已安装
    localStorage.setItem('pwaInstalled', '2')
    return true
  }
  return false
}

export const isInPWA = checkIfInPWA()

export const isPwaInstalled =
  isInPWA || localStorage.getItem('pwaInstalled') === '2'

// 检测是否为添加到iOS桌面应用
export const isFromIOSScreen = isIOS && window.navigator.standalone

// 检测是否是facebook浏览器
export const isFacebookApp = /FBAV|FBAN|FBIOS|FB|FACEBOOK/i.test(
  parser.getBrowser().name,
)

// 检测是否是chrome浏览器
// export const isChrome = /Chrome/i.test(parser.getBrowser().name)

export const hasJsBridge = typeof window.jsBridge !== 'undefined' || mockApp
export const hasOwnBridge = typeof window.ownBridge !== 'undefined' || mockApp

// 检测是否在浏览器app中 // 不一定可靠
// const isInBrowserApp = /chrome|safari|firefox|opera|edge/i.test(ua)

// 检测是否是在ios app且不在facebook浏览器且不在浏览器app中
export const isInIosApp = isIOS && hasJsBridge && !isFacebookApp

export const isInAndroidApp =
  (isAndroid && hasJsBridge && !isFacebookApp) ||
  params.get('platform') == 'Android'

export const isInApp = isInIosApp || isInAndroidApp
export const isWebView = /wv|WebView/i.test(navigator.userAgent) || isInApp

// 检测是否在浏览器
export const isInBrowser = !isInApp && !isInPWA && !isFromIOSScreen

export const isInIframe = window.self !== window.top

export const hasNetwork = ref(true)

export const ch = getAndSetLocalStorageValue('ch')

export const gp = params.get('gp')

export const type = params.get('type')

export const platform = params.get('pf')

export const pixelId = params.get('pi') || localStorage.getItem('pi') || null
export const channelType = params.get('ct') || localStorage.getItem('ct') || null

export const fromActivityId = getAndSetLocalStorageValue('ai')
export const referralCode = getAndSetLocalStorageValue('ic')
export const rewardId = getAndSetLocalStorageValue('ri')

export const currentDomain = params.get('cd')
export const preventionJump = params.get('pj')
export const activityType = getAndSetLocalStorageValue('activityType')
export const click_id = getAndSetLocalStorageValue('click_id')
export const sealing = params.get('preventionJump') === 'true' //防封域名进入
// export const language = params.get('language') || 'pt';
// export const themeStr = params.get('theme') || 'theme1';

function saveDeviceName() {
  let deviceName = localStorage.getItem('deviceName')
  if (!deviceName) {
    if (parser.getDevice().vendor) {
      deviceName = parser.getDevice().vendor + ' ' + parser.getDevice().model
    } else {
      deviceName = parser.getOS().name
    }

    localStorage.setItem('deviceName', deviceName)
  }
}

saveDeviceName()

export const deviceName = localStorage.getItem('deviceName')

export const showVconsole = localStorage.getItem('_v') == 1 || debug

function getAndSetLocalStorageValue(key) {
  const value = params.get(key) || localStorage.getItem(key) || ''
  if ((key === 'ic' || key === 'ai') && params.get('fbParams')) {
    const fbParams = atob(params.get('fbParams') || '')
    const fbParamsObj = fbParams.split('&').reduce((acc, curr) => {
      const [key, value] = curr.split('=')
      acc[key] = value
      return acc
    }, {})
    console.log('fbParamsObj', fbParamsObj)
    localStorage.setItem(key, fbParamsObj[key])
    return fbParamsObj[key] || ''
  }
  if (value) localStorage.setItem(key, value)
  return value
}

// 检测是否是在安卓包中且不是马甲包
export const isEdge =
  window.navigator.userAgent.includes('Edge') ||
  window.navigator.userAgent.includes('Edg/') ||
  window.navigator.userAgent.includes('EdgiOS')

export const isChrome = (function () {
  try {
    var e = window.navigator.userAgent.toLowerCase()
    var t = window.chrome || e.includes('chrome')
    if (!t) return false
    if (isEdge) return false
    if (e.includes('opr')) return false
    return true
  } catch (r) {
    return false
  }
})()

export const isTemplate = location.pathname.indexOf('/template') !== -1
export const isPlatform = params.get('platform') == 'Android' || isInAndroidApp
export const isIOSSafari =
  /iPad|iPhone|iPod/.test(window.navigator.userAgent) &&
  !window.MSStream &&
  /Safari/.test(window.navigator.userAgent)
export const isMobile = isIOS || isAndroid